module.exports = __webpack_public_path__ + "static/media/search-profiles.869bf09f.png";